import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import PropTypes from 'prop-types';
import { BASE_PATH } from '../../../basePath';

// eslint-disable-next-line react/prefer-stateless-function
export class Swagger extends React.Component {
  componentDidMount() {
    document.title = 'NCEI Hazard API Documentation';
  }

  render() {
    const { apiToken } = this.props;
    return (
      <SwaggerUI
        url={`${BASE_PATH}/hazard-service/docs/api.json`}
        deepLinking
        displayOperationId={false}
        defaultModelsExpandDepth={1}
        defaultModelExpandDepth={1}
        defaultModelRendering="example"
        displayRequestDuration={false}
        docExpansion="none"
        filter={false}
        operationsSorter="alpha"
        showExtensions={false}
        tagsSorter="alpha"
        validatorUrl=""
        apisSorter="alpha"
        jsonEditor={false}
        showRequestHeaders={false}
        requestInterceptor={(r) => {
          if (apiToken) {
            // eslint-disable-next-line no-param-reassign
            r.headers.authorization = `Bearer ${apiToken}`;
          }
          return r;
        }}
      />
    );
  }
}

Swagger.propTypes = {
  apiToken: PropTypes.string.isRequired,
};
